// CopyToClipboardButton.tsx
import { Button, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import React from "react";

interface CopyToClipboardButtonProps {
    onCopy: () => Promise<void>; // callback that returns a Promise
    disabled?: boolean;
    className?: string;
    style?: React.CSSProperties;
    size?: "small" | "middle" | "large";
    text?: string;
}

export const CopyElementToClipboard: React.FC<CopyToClipboardButtonProps> = ({
    onCopy,
    disabled = false,
    className,
    style,
    size = "small",
    text = "",
}) => {
    const [messageApi, contextHolder] = message.useMessage();

    const handleClick = async () => {
        try {
            await onCopy();
            messageApi.success("Copied to clipboard");
        } catch (err) {
            console.error("Copy failed:", err);
            messageApi.error("Failed to copy");
        }
    };

    return (
        <>
            {contextHolder}
            <Button
                size={size}
                type="text"
                icon={<CopyOutlined />}
                className={className}
                disabled={disabled}
                style={style}
                onClick={handleClick}
            >
                {text}
            </Button>
        </>
    );
};
